import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainPointsSection } from '../components/PainPointsSection';
import { SolutionSection } from '../components/SolutionSection';
import { BonusSection } from '../components/BonusSection';
import { PricingSection } from '../components/PricingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-cream-100 font-sans text-warm-gray selection:bg-peach-200 selection:text-terracotta-700 bg-paper" data-id="element-178">
      <main data-id="element-179">
        <HeroSection data-id="element-180" />
        <PainPointsSection data-id="element-181" />
        <SolutionSection data-id="element-182" />
        <BonusSection data-id="element-183" />
        <PricingSection data-id="element-184" />
      </main>
      <Footer data-id="element-185" />
    </div>;
}